import { MdInfo } from 'react-icons/md';
import CircleIcon from 'components/CircleIcon';
import DataItem from 'components/DataItem';
import SectionTitle from 'components/typography/SectionTitle';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { B2B_ENABLED } from 'shared/constants/appConfig';
import { displayDate, getFullname } from 'shared/helpers/common';

export default function Overview({ data, isBooking = false }) {
  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();

  const getLeadPassenger = (passengers) => {
    const leadPassenger = passengers.find(
      (passenger) => passenger.lead === true,
    );
    return `${getFullname(leadPassenger)}`;
  };

  return (
    <>
      <div className="mt-[40px] flex items-start">
        <CircleIcon className="mt-1">
          <MdInfo style={{ fill: primaryColour }} />
        </CircleIcon>
        <SectionTitle label="Overview" className="ml-[10px] mt-1" />
      </div>
      <div className="mt-[5px] lg:mt-[10px] flex flex-wrap">
        <DataItem
          label="Name"
          value={
            B2B_ENABLED
              ? getLeadPassenger(data?.passengers)
              : `${data?.visitor?.fullName?.first} ${data?.visitor?.fullName?.last}`
          }
        />
        <DataItem
          label={isBooking ? 'Booked' : 'Created'}
          value={displayDate(data.created, '-', undefined, true)}
        />
        <DataItem
          label={isBooking ? 'Booking reference' : 'Quote reference:'}
          value={data?.reference}
        />
        <DataItem label="Date from" value={displayDate(data.outbound, '-', undefined, true)} />
        <DataItem label="Date to" value={displayDate(data.inbound, '-', undefined, true)} lastItem />
      </div>
    </>
  );
}
